import React, { useEffect } from 'react'

export default function SEOHead({
  title = 'Agstner Byg ApS',
  description = 'Agstner Byg ApS udfører professionelt tømrerarbejde, tagarbejde og renovering i Vissenbjerg og på Fyn. Kontakt os for et uforpligtende tilbud.',
  canonicalUrl = 'https://agstnerbyg.dk',
  ogImage = 'https://assets.auxodev.dk/assets/bac61bd8-01e8-4025-a9be-38664430d08c/agstner-hero-carpentry.jpg'
}) {
  useEffect(() => {
    document.title = title
    
    // Update or create meta description
    let metaDesc = document.querySelector('meta[name="description"]')
    if (!metaDesc) {
      metaDesc = document.createElement('meta')
      metaDesc.name = 'description'
      document.head.appendChild(metaDesc)
    }
    metaDesc.content = description

    // Update OG tags
    const ogTags = [
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: ogImage },
      { property: 'og:type', content: 'website' }
    ]

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property="${property}"]`)
      if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute('property', property)
        document.head.appendChild(tag)
      }
      tag.content = content
    })

    // LocalBusiness Schema JSON-LD
    const schemaData = {
      '@context': 'https://schema.org',
      '@type': 'HomeAndConstructionBusiness',
      'name': 'Agstner Byg ApS',
      'image': 'https://assets.auxodev.dk/assets/bac61bd8-01e8-4025-a9be-38664430d08c/ag-logo.png',
      'telephone': '+4552502543',
      'email': 'Agstnerbyg@icloud.com',
      'address': {
        '@type': 'PostalAddress',
        'streetAddress': 'Odensevej 36',
        'addressLocality': 'Vissenbjerg',
        'postalCode': '5492',
        'addressCountry': 'DK'
      },
      'identifier': '44000997',
      'sameAs': [
        'https://www.facebook.com/profile.php?id=61590981091175'
      ],
      'areaServed': ['Vissenbjerg', 'Odense', 'Fyn'],
      'priceRange': '$$'
    }

    let scriptTag = document.querySelector('#local-business-schema')
    if (!scriptTag) {
      scriptTag = document.createElement('script')
      scriptTag.id = 'local-business-schema'
      scriptTag.type = 'application/ld+json'
      document.head.appendChild(scriptTag)
    }
    scriptTag.textContent = JSON.stringify(schemaData)
  }, [title, description, canonicalUrl, ogImage])

  return null
}
